import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { ExternalLink, Info, X } from 'react-feather';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { getUserIcon, isDirectMessage, isGroupDirectMessage, isSelfDirectMessage } from '../../helpers/ChatUtils';
import User from '../User/UserContainer';
import MobileMenuToggle from '../MobileMenuToggle/MobileMenuToggleContainer';


export default class ChatPanelOverview extends Component {
  static propTypes = {
    chat: PropTypes.object.isRequired,
    identity: PropTypes.object,
    isSelectingMessages: PropTypes.bool,
    selectedMessageCount: PropTypes.number,
    cancelSelectMessages: PropTypes.func,
    setSelectMessages: PropTypes.func,
  };

  enableSelectMessages = () => this.props.setSelectMessages(true);

  disableSelectMessages = () => this.props.setSelectMessages(false);

  /**
   * Closes message selection mode and clears the selected messages in the current chat.
   */
  cancelSelectMessages = () => {
    const { setSelectMessages, cancelSelectMessages, chat } = this.props;
    setSelectMessages(false);
    cancelSelectMessages(chat.id);
  };

  buildAndSendMessages = (e) => {
    const { buildAndSendExportToInbox, chat } = this.props;
    buildAndSendExportToInbox(chat.id);

    this.disableSelectMessages();

    // Remove focus from the send to inbox button
    e.target.blur();
  };

  sendMessages = () => {
    const { sendExportToInbox, chat } = this.props;
    sendExportToInbox(chat.id);

    this.disableSelectMessages();
  };

  render() {
    const { chat, identity, pdf, isSelectingMessages, selectedMessageCount } = this.props;

    return (
      <div className="chat-panel-header">
        <div className="chat-panel-overview" data-qa="chatPanelHeading">
          <MobileMenuToggle/>
          <UserIconLink chat={chat}/>
          <ChatTitle chat={chat} identityId={identity.id}/>
          <SelectMessagesLink
            isSelectingMessages={isSelectingMessages}
            onEnableSelectMessages={this.enableSelectMessages}
            onCancelSelectMessages={this.cancelSelectMessages}
          />
          <InfoIconLink chatId={chat.id}/>
        </div>
        {isSelectingMessages &&
          <div className="select-messages-options">
            <button onClick={this.cancelSelectMessages}>CANCEL</button>
            <div>{selectedMessageCount} Selected</div>
            <button disabled={selectedMessageCount === 0 || pdf.isSending} onClick={this.buildAndSendMessages}>SEND TO INBOX</button>
          </div>
        }
      </div>
    );
  }
};

const UserIconLink = ({ chat }) => {
  const chatId = chat.id;
  const numUsers = chat.users && chat.users.length;
  return (
    <Link to={`/chat/${chatId}/details`} className="icon-button icon-user" data-qa="userIconLink">
      {getUserIcon(chat)}
      <span>{numUsers}</span>
    </Link>
  );
};

const ChatTitle = ({ chat, identityId }) => {
  let titleContent;
  if (isDirectMessage(chat) && !isGroupDirectMessage(chat)) {
    const userId = isSelfDirectMessage(chat) ? chat.users[0] : chat.users.filter(u => u !== identityId)[0];
    titleContent = <User id={userId} hideAvatar hideMentionName noPad />;
  } else {
    titleContent = chat.name;
  }

  return <h1 className="chat-title" title={chat.name}>{titleContent}</h1>;
};

class SelectMessagesLink extends Component {
  handleClick = () => {
    const { isSelectingMessages, onEnableSelectMessages, onCancelSelectMessages } = this.props;
    !isSelectingMessages ? onEnableSelectMessages() : onCancelSelectMessages();
  };

  render() {
    const { isSelectingMessages } = this.props;
    return (
      <button
        onClick={this.handleClick}
        className={classnames({
          'icon-button': true,
          'icon-share': true,
          'active': isSelectingMessages,
        })}
        data-qa={isSelectingMessages ? 'closeSelectMessagesIconLink' : 'openSelectMessagesIconLink'}
      >
        {!isSelectingMessages ? (
          <ExternalLink size={20} />
        )  : (
          <X size={20} />
        )}
      </button>
    );
  }
}

const InfoIconLink = ({ chatId }) => {
  return (
    <Link
      to={`/chat/${chatId}/details`}
      className="icon-button"
      data-qa="infoIconLink"
    >
      <Info size={20} />
    </Link>
  );
};
